import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { EstatePlanningRecommendationQuizRecommendationStepLayout } from './Layout';
import { metaOverrideSet } from '../metaOverrideSet';

export const EstatePlanningRecommendationQuizRecommendationStepTemplate = ({ resource }) => {
  useBoneBackgroundColor();

  return (
    <MetaResourceRenderer
      resource={resource}
      layout={EstatePlanningRecommendationQuizRecommendationStepLayout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};


EstatePlanningRecommendationQuizRecommendationStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
